/* eslint-disable no-undef */
import "./src/styles/index.scss";

import { Tracking } from "@lg-cfa/components";
import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { RecoilRoot } from "recoil";

import { FlowContext } from "./src/context/FlowContext";
import { useStateListener } from "./src/hooks";

window.dataLayer = window.dataLayer || [];

const HookLoader = () => {
    useStateListener();
    return null;
};

export const wrapRootElement = ({ element }) => {
    return (
        <HelmetProvider>
            <RecoilRoot>
                {element}
                <Tracking />
                <HookLoader />
            </RecoilRoot>
        </HelmetProvider>
    );
};

export const wrapPageElement = ({ element, props }) => {
    return (
        <FlowContext.Provider value={props.pageContext.flow}>
            {element}
        </FlowContext.Provider>
    );
};
